export default "__VITE_ASSET__044ca2ee__"